const triggerRouterVerifyRecoveryFactor= (otp,country, lang, sessionId) => {
    const headersVerifyRecoveryFactor = new Headers();
    const countryUpperCase = country.toUpperCase();
    const uniqueId = `web-` + generateUniqueID();
    headersVerifyRecoveryFactor.append("x-wu-operationname", "verifyRecoveryFactor");
    headersVerifyRecoveryFactor.append("Content-Type", "application/json");
    headersVerifyRecoveryFactor.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersVerifyRecoveryFactor.append("wucountrycode", countryUpperCase);
    headersVerifyRecoveryFactor.append("wulanguagecode", lang);
    headersVerifyRecoveryFactor.append("x-wu-externalRefId", uniqueId);
    headersVerifyRecoveryFactor.append("x-wu-correlationId", uniqueId);
    headersVerifyRecoveryFactor.append("x-wu-session-version", `3`);
    headersVerifyRecoveryFactor.append("version", `V2`);
    headersVerifyRecoveryFactor.append("x-wu-sessionId", sessionId);
    headersVerifyRecoveryFactor.append("x-wu-apiKey", `1978`);
    headersVerifyRecoveryFactor.append("flowname", `REGISTRATION`);
    headersVerifyRecoveryFactor.append("isrrenabled", true);
    headersVerifyRecoveryFactor.append("passwordRecovery", true);
    headersVerifyRecoveryFactor.append("x-wu-retailSessionId", "");
    headersVerifyRecoveryFactor.append("accept-language", `${lang}-${countryUpperCase}`);
  
    let verifyRecoveryFactorInput = {
        otp
    };

    const graphql = JSON.stringify({
      query: window.queryData.verifyRecoveryFactorQuery,
      variables: {
        args_RecoveryFactorsInput: verifyRecoveryFactorInput,
      },
    });
    const requestOptions = {
      method: "POST",
      headers: headersVerifyRecoveryFactor,
      body: graphql,
      redirect: "follow",
    };
  
    return fetchApiWu(routerUrl, requestOptions, "verifyRecoveryFactor")
  };
  
window.queryData.triggerRouterVerifyRecoveryFactor = triggerRouterVerifyRecoveryFactor